import React, { useState } from "react";
import { motion } from "framer-motion";
import { Button, Avatar } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import "./ViewBadgesPublicComponent.css";
import { profileImages } from "../../../utils/constants";
import TechJobCard from "./TechJobCard";
import RecognizedBySection from "./RecognizedBySection";
import WorkshopFooterPage from "../Workshops/WorkshopFooter";
import McqSelectionPage from "./McqSelectionPage";

const ViewBadgesPublicComponent = () => {
  const userName = "Test User";
  const techStack = "React.js";
  const earnedDate = "10th Oct 2025";

  // Get initials from name
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  const mobileRegisteredUsers = () => (
    <div className="viewbadgepublic-registered-users">
      {profileImages.map((item) => (
        <Avatar
          key={item}
          sx={{ width: "30px", height: "30px" }}
          src={item}
          className="viewbadgepublic-avatar-overlap"
        />
      ))}
      <p className="viewbadgepublic-registered-text">
        +700 Students have earned Badges
      </p>
    </div>
  );

  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
  };

  return (
    <div className="viewbadgespublic-container">
      {/* User Info Section */}
      <div className="viewbadgespublic-user-section">
        <Avatar className="viewbadgespublic-avatar">
          {getInitials(userName)}
        </Avatar>
        <p className="viewbadgespublic-success-text">
          <span className="viewbadgespublic-username">{userName}</span> has
          successfully earned the{" "}
          <span className="viewbadgespublic-tech-highlight">
            {techStack} Badge
          </span>{" "}
          by Completing the MCQ based Skill Assessment.
        </p>
      </div>

      {/* Badge Image with Breathing Animation */}
      <motion.div className="viewbadgespublic-badge-wrapper">
        <img
          src="/path-to-your-badge-image.png"
          alt={`${techStack} Badge`}
          className="viewbadgespublic-badge-image"
        />
      </motion.div>

      {/* Earned Date */}
      <p className="viewbadgespublic-earned-date">Earned on {earnedDate}</p>

      {/* Verified By Section */}
      <div className="viewbadgespublic-verified-section">
        <VerifiedIcon className="viewbadgespublic-verified-icon" />
        <span className="viewbadgespublic-verified-text">
          Verified by Acetechies Academy
        </span>
      </div>

      {/* CTA Button */}
      <Button
        onClick={handleOpenDrawer}
        className="certificatelanding-btn-primary"
      >
        Earn Your Own Badge
      </Button>
      {mobileRegisteredUsers()}
      <div className="viewbadgepublic-section-cards-container">
        <h2 className="viewbadgepublic-section-title">
          Land your next Tech Job or Internship
        </h2>
        <p className="viewbadgepublic-section-subtitle">
          Get Certified and land your next Internship or Job. Our verified
          certificates place students and professionals in the top 5%.
        </p>
        <div className="techjob-cards-container">
          <TechJobCard
            image="/path/to/frontend-dev.png"
            title="Frontend Developer"
            onClick={() => console.log("Navigate to Frontend roles")}
          />

          <TechJobCard
            image="/path/to/backend-dev.png"
            title="Backend Developer"
            onClick={() => console.log("Navigate to Backend roles")}
          />
          <TechJobCard
            image="/path/to/data-scientist.png"
            title="Data Scientist"
            onClick={() => console.log("Navigate to Data Science roles")}
          />
          <TechJobCard
            image="/path/to/devops-engineer.png"
            title="DevOps Engineer"
            onClick={() => console.log("Navigate to DevOps roles")}
          />
        </div>
      </div>
      <div style={{ width: "100%" }}>
        <RecognizedBySection />
      </div>
      <McqSelectionPage open={drawerOpen} onClose={handleCloseDrawer} />
      <WorkshopFooterPage />
    </div>
  );
};

export default ViewBadgesPublicComponent;
